import React, { useState } from 'react';
import CustomTextField from '../CustomTextField/CustomTextField.js';
import { Button, MenuItem, Checkbox, FormControlLabel, CircularProgress } from '@mui/material';
import './ContactForm.scss';
import { optionsForWhatsDescribesYou } from '../Common/Constant.js';
import { set } from 'lodash';
import GenericDialog from '../GenericDialog/GenericDialog.js';


const INITIAL_DATA = {
    firstName: '',
    lastName: '',
    phoneNumber: '',
    workEmail: '',
    city: '',
    companyName: '',
    description: '',
    help: '',
};

const ContactForm = ({ className }) => {
    const [dialogState, setDialogState] = useState({
        open: false,
        title: '',
        message: '',
        severity: 'success'
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [formData, setFormData] = useState(INITIAL_DATA);
    const [formDataErrors, setFormDataErrors] = useState({
        firstName: '',
        lastName: '',
        phoneNumber: '',
        workEmail: '',
        city: '',
        companyName: '',
        description: '',
        help: '',
    });

    const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000';

    const handleFieldError = (name, value) => {
        const formDataErrorsState = { ...formDataErrors };
        switch (name) {
            case 'firstName':
                formDataErrorsState.firstName = !value
                    ? 'First Name is Required'
                    : '';
                break;
            case 'lastName':
                formDataErrorsState.lastName = !value
                    ? 'Last Name is Required'
                    : '';
                break;
            case 'phoneNumber':
                formDataErrorsState.phoneNumber = !value
                    ? 'Phone Number is Required'
                    : '';
                break;
            case 'workEmail':
                formDataErrorsState.workEmail = !value
                    ? 'Email is Required'
                    : '';
                break;
            case 'city':
                formDataErrorsState.city = !value
                    ? 'City Name is Required'
                    : '';
                break;
            case 'companyName':
                formDataErrorsState.companyName = !value
                    ? 'Company Name is Required'
                    : '';
                break;
            case 'description':
                formDataErrorsState.description = !value
                    ? 'Description is Required'
                    : '';
                break;
            case 'help':
                formDataErrorsState.help = !value
                    ? 'Help Field is Required'
                    : '';
                break;
            default:
                break;
        }
        setFormDataErrors(formDataErrorsState);
    };

    const validateErrors = () => {
        let valid = true;
        const formDataErrorsState = { ...formDataErrors };
        if (!formData.firstName) {
            formDataErrorsState.firstName = 'First Name is Required';
            valid = false;
        }
        if (!formData.lastName) {
            formDataErrorsState.lastName = 'Last Name is Required';
            valid = false;
        }
        if (!formData.phoneNumber) {
            formDataErrorsState.phoneNumber = 'Phone Number is Required';
            valid = false;
        }
        if (!formData.workEmail) {
            formDataErrorsState.workEmail = 'Email is Required';
            valid = false;
        }
        if (!formData.city) {
            formDataErrorsState.city = 'City Name is Required';
            valid = false;
        }
        if (!formData.companyName) {
            formDataErrorsState.companyName = 'Company Name is Required';
            valid = false;
        }
        if (!formData.description) {
            formDataErrorsState.description = 'Description is Required';
            valid = false;
        }
        if (!formData.help) {
            formDataErrorsState.help = 'Help Field is Required';
            valid = false;
        }
        setFormDataErrors(formDataErrorsState);
        return valid;
    };

    const clearFieldError = (name) => {
        const formDataErrorsState = { ...formDataErrors };
        formDataErrorsState[name] = '';
        setFormDataErrors(formDataErrorsState);
    };

    const handleChange = (e, checkForErrors = true) => {
        if (!validateErrors) return;
        const formDataState = { ...formData };
        const {
            name, value
        } = e.target;
        clearFieldError(name);

        set(formDataState, name, value);
        setFormData(formDataState);
        if (checkForErrors) handleFieldError(name, value);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateErrors()) return;

        setIsSubmitting(true);
        try {
            const response = await fetch(`${API_BASE_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });

            if (response.ok) {
                setDialogState({
                    open: true,
                    title: 'Success',
                    message: 'Your message has been sent successfully.',
                    severity: 'success'
                });
                setFormData(INITIAL_DATA);
                setIsChecked(false);
            } else {
                const errorMessage = await response.text();
                setDialogState({
                    open: true,
                    title: 'Error',
                    message: errorMessage || 'There was an issue sending your message. Please try again.',
                    severity: 'error'
                });
            }
        } catch (error) {
            setDialogState({
                open: true,
                title: 'Error',
                message: 'An error occurred. Please try again later.',
                severity: 'error'
            });
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className={`contact-form ${className}`}>
            <div className="form-section">
                <h2>Speak to our team</h2>
                <form onSubmit={handleSubmit}>
                    <div className="form-row">
                        <CustomTextField
                            label="First Name"
                            type="text"
                            name="firstName"
                            value={formData.firstName}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            fullWidth
                            error={!!formDataErrors.firstName}
                            helperText={formDataErrors.firstName}
                            className='custom-text-field'
                        />
                        <CustomTextField
                            label="Last Name"
                            name="lastName"
                            value={formData.lastName}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            fullWidth
                            error={!!formDataErrors.lastName}
                            helperText={formDataErrors.lastName}
                            className='custom-text-field'

                        />
                    </div>

                    <div className="form-row">
                        <CustomTextField
                            type="number"
                            label="Phone Number"
                            name="phoneNumber"
                            value={formData.phoneNumber}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            fullWidth
                            error={!!formDataErrors.phoneNumber}
                            helperText={formDataErrors.phoneNumber}
                            className='custom-text-field'
                        />
                        <CustomTextField
                            label="Work Email"
                            name="workEmail"
                            value={formData.workEmail}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            fullWidth
                            error={!!formDataErrors.workEmail}
                            helperText={formDataErrors.workEmail}
                            className='custom-text-field'
                        />
                    </div>

                    <div className="form-row">
                        <CustomTextField
                            label="City"
                            name="city"
                            value={formData.city}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            fullWidth
                            error={!!formDataErrors.city}
                            helperText={formDataErrors.city}
                            className='custom-text-field'
                        />
                        <CustomTextField
                            required
                            label="Company Name"
                            name="companyName"
                            variant="outlined"
                            value={formData.companyName}
                            onChange={handleChange}
                            onBlur={handleChange}
                            fullWidth
                            error={!!formDataErrors.companyName}
                            helperText={formDataErrors.companyName}
                            className='custom-text-field'
                        />
                    </div>

                    <div className="form-row form-row-select">
                        <select
                            name="description"
                            value={formData.description}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            className='custom-text-field'
                        >
                            <option value="">Which describes you best? *</option>
                            {optionsForWhatsDescribesYou.map((val) => (
                                <option
                                    value={val.value}
                                    key={val.value}
                                >
                                    {val.label}
                                </option>
                            ))}
                        </select>
                        {formDataErrors.description && (
                            <span className="error-message">
                                {formDataErrors.description}
                            </span>
                        )}
                    </div>

                    <div className="form-row">
                        <CustomTextField
                            label="How can we help?"
                            name="help"
                            value={formData.help}
                            onChange={handleChange}
                            onBlur={handleChange}
                            required
                            multiline
                            rows={4}
                            fullWidth
                            error={!!formDataErrors.help}
                            helperText={formDataErrors.help}
                            className='custom-text-field'
                        />
                    </div>

                    <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? (
                            <CircularProgress size={24} color="inherit" />
                        ) : (
                            'Submit'
                        )}
                    </Button>
                </form>
            </div>
            <GenericDialog
                open={dialogState.open}
                onClose={() => setDialogState({ ...dialogState, open: false })}
                title={dialogState.title}
                message={dialogState.message}
                severity={dialogState.severity}
            />
        </div>
    );
};

export default ContactForm;
